export function dunsApplicationReducer(prevState : any = {}, action : any = {}) {
    switch (action.type) {
        case 'SAVE_APPLICATION':
            return action.savedApplication;
        case 'CLEAR_APPLICATION':
            return {};
        default:
            return prevState;
    }
}

export function dunsInfoReducer(prevState : any = {}, action : any = {}) {
    switch (action.type) {
        case 'SAVE_DUNS_INFO':
            return action.dunsInfo;
        default:
            return prevState;
    }
}

export function dunsSignupEmailReducer(prevState : any = {}, action : any = {}) {
    switch (action.type) {
        case 'SAVE_DUNS_SIGNUP_EMAIL':
            return action.dunsSignupEmail;
        default:
            return prevState;
    }
}

export function dunsApplicationProgressReducer(prevState : any = {}, action : any = {}) {
    switch (action.type) {
        case 'SAVE_DUNS_APPLICATION_PROGRESS_INFO':
            return action.payload;
        default:
            return prevState;
    }
}
